<template>
    <svg class="download-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 7V14M12 14L15 11M12 14L9 11" stroke="#0000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 17H16" stroke="#0000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4 12V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12" stroke="#0000FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>